var NotFoundPage = React.createClass({

  render: function () {
    return (
      <Esk.Helper.LayoutHelper.fullPageLayout className="error-page">
        <Esk.Helper.LayoutHelper.fullPageLayoutHeader>
          <Esk.Helper.LayoutHelper.fullPageLayoutLogo />
        </Esk.Helper.LayoutHelper.fullPageLayoutHeader>

        <Esk.Helper.LayoutHelper.errorLayout
          error={new Esk.Utils.AppError(404)}/>
      </Esk.Helper.LayoutHelper.fullPageLayout>

    );
  }
});

module.exports = NotFoundPage;
